import { Entity, IEntity } from '../../domain/entity'
import { hashCode } from '../common/hash-code'
import { prune } from '../common/prune'
import { XDActions } from './actions'

export interface IXDMessage<T> extends IEntity {
    action: XDActions
    data?: T
    hash: number
    ts: number

    /**
     * Returns a pruned version of the message. For minimal bandwidth usage.
     */
    send(): object

    /**
     * Validates the message hash and timestamp.
     */
    validate(): boolean
}

export class XDMessage<T> extends Entity implements IXDMessage<T> {
    public static lifespanMs = 30000 // allow some processing lag (msg could be created before xd is ready)
    public hash: number

    constructor(
        public readonly action: XDActions,
        public data?: T,
        public readonly ts = Date.now(),
        hash?: number) {

        super()
        this.updateHash(hash)
    }

    public fromJson(jsonObject: object) {
        super.fromJson(jsonObject)

        // entity builder ignores objects
        if (jsonObject && (jsonObject as this).data) {
            this.data = (jsonObject as this).data
        }

        return this
    }

    public send() {
        return prune(this)
    }

    public validate() {
        const { hash, ...rest } = prune(this)
        return hash === hashCode(rest) && Date.now() - this.ts < XDMessage.lifespanMs
    }

    protected updateHash(set: number) {
        const { hash, ...rest } = prune(this)
        this.hash = set || hashCode(rest)
    }
}
